// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { useAggregationData } from '@shared/advisory/aggregation/providers';
import { useTabsController } from '@shared/ui-kit';
import { useSearchParams } from 'react-router';

export const useInvestment = () => {
  const {
    accountOptions,
    onChangeAccounts,
    selectedAccounts,
    onRefresh,
    status,
    updatedDate,
    refreshMode,
    currency,
    isSyncing,
    tags,
    tagsByObject,
    selectedTag,
    setSelectedTag,
  } = useAggregationData();

  const [params, setParams] = useSearchParams();

  const tabsController = useTabsController(
    params.get('tab') ?? undefined,
    undefined,
    tab => {
      setParams(
        prev => {
          const next = new URLSearchParams(prev);
          next.set('tab', tab);
          return next;
        },
        { replace: true },
      );
    },
    [params.get('tab')],
  );

  return {
    accountOptions,
    onChangeAccounts,
    selectedAccounts,
    onRefresh,
    status,
    tabsController,
    tags,
    tagsByObject,
    selectedTag,
    setSelectedTag,
    updatedDate,
    refreshMode,
    currency,
    isSyncing,
  };
};
